<claas-header [showMenuIconButton]="false" [title]="'app.title' | translate"></claas-header>
<router-outlet></router-outlet>
